import { Component, Input } from '@angular/core';
import { ObservationTypeValues } from 'src/app/model/enum/observation-type-values.enum';
import { ObservationListService } from 'src/app/services/observation-list.service';

@Component({
    selector: 'app-observation-print',
    templateUrl: './observation-print.component.html',
    styleUrls: ['./observation-print.component.scss']
})
export class ObservationPrintComponent {
    @Input() observationType?: number;
    @Input() observationId?: string;
    @Input() targetUserId?: string;

    constructor(
        private observationListService: ObservationListService,
    ) { }

    openPrintPreview() {
        if (this.observationType && this.observationId && this.targetUserId) {
            this.observationListService.openPrintPreview(this.observationType as ObservationTypeValues, this.observationId, this.targetUserId);
        }
    }
}
